"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _constants = require("../constants/constants");
var _validate = require("../apis/bwa/validate");
var _utils = require("../utils/utils");
var VariantWatcher = /*#__PURE__*/function () {
  function VariantWatcher() {
    (0, _classCallCheck2["default"])(this, VariantWatcher);
    this.variantObserver = null;
  }
  return (0, _createClass2["default"])(VariantWatcher, [{
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              try {
                this.observeVariantChanges();
              } catch (error) {
                console.error("Error initializing VariantWatcher:", error);
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "emitVariantChanges",
    value: function () {
      var _emitVariantChanges = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var validateSkuResponse, event;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _validate.validateSku)(window.storeId, (0, _utils.getVariantId)(window.bwaMerchantConfig.bwaDeliveryBlock.variantIdSelector));
            case 2:
              validateSkuResponse = _context2.sent;
              window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.BWA_PRODUCT_VIEWED, {
                detail: {
                  bwaEnabled: validateSkuResponse === null || validateSkuResponse === void 0 ? void 0 : validateSkuResponse.isSkuEnabled,
                  reviewsEnabled: validateSkuResponse === null || validateSkuResponse === void 0 ? void 0 : validateSkuResponse.isReviewsSkuEnabled,
                  ratingsEnabled: validateSkuResponse === null || validateSkuResponse === void 0 ? void 0 : validateSkuResponse.isRatingsSkuEnabled
                }
              }));
              event = new CustomEvent(_constants.EVENT_TYPE.CUSTOM.VARIANT_UPDATED, {
                detail: {
                  validateSkuResponse: validateSkuResponse
                }
              });
              window.dispatchEvent(event);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function emitVariantChanges() {
        return _emitVariantChanges.apply(this, arguments);
      }
      return emitVariantChanges;
    }()
  }, {
    key: "observeVariantChanges",
    value: function observeVariantChanges() {
      var _this = this;
      if (this.variantObserver) return;
      this.variantObserver = new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          var urlParams = new URLSearchParams(window.location.search);
          var currentVariantId = urlParams.get('variant');
          if (currentVariantId && (!_this.previousVariantId || currentVariantId !== _this.previousVariantId)) {
            _this.previousVariantId = currentVariantId;
            _this.emitVariantChanges();
          }
        });
      });
      this.variantObserver.observe({
        entryTypes: ["resource"]
      });
    }
  }]);
}();
var _default = exports["default"] = new VariantWatcher();
//# sourceMappingURL=variant-watcher.js.map
